import styled from "styled-components";
import Link from "next/link";

export const PageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

export const Container = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8rem 2rem 4rem;
  background: linear-gradient(135deg, #c8553d 0%, #f2853b 100%);

  @media (max-width: 768px) {
    padding: 5rem 1rem 4rem;
  }
`;

export const Card = styled.div`
  background: white;
  border-radius: 16px;
  padding: 3rem;
  width: 100%;
  max-width: 450px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
`;

export const Title = styled.h1`
  font-size: 2rem;
  font-weight: 800;
  color: #333;
  margin-bottom: 0.5rem;
  text-align: center;
`;

export const Subtitle = styled.p`
  color: #666;
  text-align: center;
  margin-bottom: 2rem;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const InputGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const Label = styled.label`
  font-weight: 600;
  color: #333;
  font-size: 0.9rem;
`;

export const Input = styled.input`
  padding: 0.875rem;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 1rem;
  transition: border-color 0.3s;

  &:focus {
    outline: none;
    border-color: #c8553d;
  }

  &::placeholder {
    color: #999;
  }
`;

export const Button = styled.button`
  padding: 1rem;
  background: #c8553d;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;

  &:hover:not(:disabled) {
    background: #b04731;
    transform: translateY(-2px);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const GoogleButton = styled(Button)`
  background: white;
  color: #333;
  border: 2px solid #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;

  &:hover:not(:disabled) {
    background: #f5f5f5;
    border-color: #c8553d;
    transform: translateY(-2px);
  }
`;

export const Divider = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin: 0.5rem 0;

  &::before,
  &::after {
    content: "";
    flex: 1;
    height: 1px;
    background: #e0e0e0;
  }

  span {
    color: #999;
    font-size: 0.875rem;
  }
`;

export const ErrorMessage = styled.div`
  padding: 0.875rem;
  background: #fee;
  border: 1px solid #fcc;
  border-radius: 8px;
  color: #c33;
  font-size: 0.9rem;
`;

export const LinkText = styled.p`
  text-align: center;
  color: #666;
  margin-top: 1.5rem;

  a {
    color: #c8553d;
    font-weight: 600;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const ForgotPassword = styled(Link)`
  color: #c8553d;
  font-size: 0.9rem;
  text-decoration: none;
  text-align: right;
  display: block;
  margin-top: -0.5rem;

  &:hover {
    text-decoration: underline;
  }
`;
